import React from 'react'
import Nav from '@softwaredev_cegeka/stix-core/dist/components/Nav'
import Navbar from '@softwaredev_cegeka/stix-core/dist/components/Navbar'

import { NavLink } from 'react-router-dom'
import UserMenu from 'src/components/Menu/UserMenu'
import { reverse } from 'src/routes/config'
import './header.scss'

const Header = ({ stripped = false }) => {
    return (
        <Navbar variant="primary-100" isRounded={false}>
            {!stripped ? (
                <>
                    <NavLink to={'/'} className="stix-navbar-brand">
                        <img
                            src="https://public.apps.cegeka.com/logos/cegeka-logo-white.svg"
                            alt={'logo'}
                            className={'logo'}
                            height="35"
                        />
                    </NavLink>
                    <Nav>
                        <Nav.Link
                            as={NavLink}
                            to={reverse('solutions', { view: 'list' })}
                        >
                            Solutions
                        </Nav.Link>
                    </Nav>
                    <Navbar.Right>
                        <UserMenu />
                    </Navbar.Right>
                </>
            ) : (
                <Navbar.Brand>
                    <img
                        src="https://public.apps.cegeka.com/logos/cegeka-logo-white.svg"
                        alt={'logo'}
                        className={'logo'}
                        height="35"
                    />
                </Navbar.Brand>
            )}
        </Navbar>
    )
}

export default Header
